import { Link } from "@remix-run/react";

export function Footer() {
  return (
    <footer className="border-t py-6 bg-slate-50 dark:bg-slate-900">
      <div className="container">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <div className="flex items-center mb-3">
              <img 
                src="/images/logo.webp" 
                alt="Weather Route Logo" 
                className="h-8 mr-2"
              />
              <h3 className="font-semibold text-lg">About Weather Route</h3>
            </div>
            <p className="text-slate-600 dark:text-slate-400">
              Your trusted weather data provider for route planning and navigation.
            </p>
          </div>
          <div>
            <h3 className="font-semibold text-lg mb-3">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-slate-600 dark:text-slate-400 hover:text-blue-600 dark:hover:text-blue-400 transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/kb" className="text-slate-600 dark:text-slate-400 hover:text-blue-600 dark:hover:text-blue-400 transition-colors">
                  Knowledge Base
                </Link>
              </li>
              <li>
                <Link to="/videos" className="text-slate-600 dark:text-slate-400 hover:text-blue-600 dark:hover:text-blue-400 transition-colors">
                  Video Tutorials
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <h3 className="font-semibold text-lg mb-3">Connect With Us</h3>
            <p className="text-slate-600 dark:text-slate-400 mb-2">
              Have questions? We&apos;re here to help!
            </p>
            <button 
              className="text-blue-600 dark:text-blue-400 hover:underline"
              onClick={() => {
                // This would normally trigger the contact form, but it's already available via the floating button
                const contactButton = document.querySelector('.fixed.bottom-4.right-4') as HTMLButtonElement;
                if (contactButton) contactButton.click();
              }}
            >
              Contact Support
            </button>
          </div>
        </div>
        <div className="mt-8 pt-4 border-t text-center text-slate-500 dark:text-slate-400">
          <p>&copy; {new Date().getFullYear()} Weather Route Inc. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
} 